import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { setCurrentMail,
  setMailOpen,
  toggleEmailTag,
  setReadStatusThunk, } from "../../store/features/emailsSlice";
import { PinIcon,FlagIcon } from "../../assets/icons/PinIcon";


const EmailCard = ({ email, isPinned = false, isHighlighted = false, onTogglePin, threadId }) => {
  const dispatch = useDispatch();
  const [isHovered, setIsHovered] = useState(false);
  // Handle pin toggle
  const handlePin = (e) => {
    e.stopPropagation();
    onTogglePin(email.emailId, isPinned);
  };

  // Handle tag toggle
  const handleTag = (e) => {
    e.stopPropagation();
    if (email && email.emailId) {
      dispatch(toggleEmailTag(threadId, email.emailId, email.tagged)); // Pass threadId, emailId, and current tagged state
    } else {
      console.error("Missing email ID for tagging.");
    }
  };

  // Handle opening email and marking as read
  const handleOpen = () => {
    if (email) {
      // Set the current email as open
      dispatch(setCurrentMail(email));
      dispatch(setMailOpen(true));

      // Update the read status in Redux and persist it
      if (email.readStatus === "unread") {
        dispatch(setReadStatusThunk(threadId, email.emailId)); // Use the thunk for persistence
      }
    } else {
      console.error("Email data is missing.");
    }
  };



  const getInitials = (input) => {
    // Extract the name part before the '<' character
    const name = input.split('<')[0].trim();
  
    // Split the name into parts, map to initials, and join them
    return name
      .split(" ")
      .map((n) => n[0])
      .join("")
      .toUpperCase();
  };

  const getBackgroundColor = (initial) => {
    const colors = [
      "#FFB6C1", "#FFD700", "#B0E57C", "#87CEEB", "#DDA0DD",
      "#FFA07A", "#98FB98", "#AFEEEE", "#F0E68C", "#E6E6FA"
    ];
  
    const charCode = initial.charCodeAt(0);
    const index = charCode % colors.length;
  
    return colors[index];
  };
  // Safely format date
  const date = email?.date_received ? new Date(email.date_received) : null;
  const formattedTime = date ? date.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }) : "N/A";
  const initials = getInitials(email?.sender|| "?");
  return (
    <div
      className={`flex items-center justify-between p-4 border rounded-md cursor-pointer ${
        isHighlighted ? "bg-bg-Dashboard" : "bg-white"
      }  hover:bg-bg-Dashboard`}
      onClick={handleOpen}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {/* Left Section: Sender Details */}
      <div className="flex gap-4 w-3/4">
        {/* Sender Initials */}
        <div className="flex-shrink-0">
        <span
          className="text-lg font-bold text-white w-10 h-10 flex items-center justify-center rounded-full"
          style={{ backgroundColor: getBackgroundColor(initials) }}
        >
          {initials}
        </span>
        </div>

        {/* Email Details */}
        <div className="overflow-hidden flex-1">
          <p className="font-bold text-gray-900 truncate">{email?.sender || "Unknown Sender"}</p>
          <p className="text-gray-600 truncate">{email?.subject || "No Subject"}</p>
          <p className="text-sm text-gray-500 truncate">{email?.shortDescription || "No Description"}</p>
        </div>
      </div>

      {/* Right Section: Time and Actions */}
      <div className="flex flex-col items-end">
        {/* Time */}
        <span className="text-gray-500 mb-1">{formattedTime}</span>

        {/* Action Icons */}
        <div className="flex items-center gap-2">
          {/* Pin Button */}
          {/* <button
            onClick={handlePin}
            className={`p-1 rounded-full ${
              isPinned ? "text-yellow-500" : isHovered ? "text-gray-400 hover:text-yellow-600" : "text-transparent"
            }`}
            title="Pin this email"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="1.5"
              stroke="currentColor"
              className="w-6 h-6"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M3 4.5h14.25M3 9h9.75M3 13.5h5.25m5.25-.75L17.25 9m0 0L21 12.75M17.25 9v12"
              />
            </svg>
          </button> */}

          {/* Tag Button */}
          {/* <button
            onClick={handleTag}
            className={`p-1 rounded-full ${
              email?.tagged ? "text-blue-500" : isHovered ? "text-gray-400 hover:text-blue-600" : "text-transparent"
            }`}
            title="Tag this email"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="1.5"
              stroke="currentColor"
              className="w-6 h-6"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M3 3v1.5M3 21v-6m0 0 2.77-.693a9 9 0 0 1 6.208.682l.108.054a9 9 0 0 0 6.086.71l3.114-.732a48.524 48.524 0 0 1-.005-10.499l-3.11.732a9 9 0 0 1-6.085-.711l-.108-.054a9 9 0 0 0-6.208-.682L3 4.5M3 15V4.5"
              />
            </svg>
          </button> */}
        </div>
      </div>
    </div>
  );
};

export default EmailCard;